<template lang="html">
    <div>
        <div class="form-group d-flex">

            <div class="col-sm-12">
                <label>Name</label>
                <div class="d-flex align-items-center">
                    <input type="text" class="w-50" v-model="salesChannel.name" placeholder="Name here" :disabled="blockNameChange">
                    <!-- <checkbox class="d-inline ml-3" name="isResseler" value="true" v-model="salesChannel.isResseler"></checkbox>
                    <label>This is a reseller</label> -->
                </div>
            </div>

        </div>

        <div class="col-sm-12">
            <h5>Advanced Settings</h5>
        </div>

        <div class="col-sm-12">
            <div class="col-sm-12">

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span class="fs-small bold">Allow to book Extras</span>
                    <toggle-button v-model="salesChannel.isAllowedSellComponents"  :labels="{checked: 'Yes', unchecked: 'No'}" />
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span class="fs-small bold" :class="{'opacity-50': disableTranpsortOption}">Allow to book Transports</span>
                    <toggle-button v-model="salesChannel.isAllowedSellTransports" :disabled="disableTranpsortOption"  :labels="{checked: 'Yes', unchecked: 'No'}" />
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span class="fs-small bold">Send notification on new booking</span>
                    <toggle-button v-model="salesChannel.notificationNewBooking"  :labels="{checked: 'Yes', unchecked: 'No'}" />
                </div>

                <div class="d-flex justify-content-between mb-2 align-items-center">
                    <div :class="{'opacity-50':!hasInvoiceSystem}">
                        <span class="fs-small bold">Automatic invoice</span>
                        <div class="fs-small dark">Automatic invoices are created when a new activity is booked for this channel.</div>
                    </div>
                    <div v-if="hasInvoiceSystem && hasInvoiceSystemActive">
                        <toggle-button v-model="salesChannel.isInvoiceAutomatic"  :labels="{checked: 'Yes', unchecked: 'No'}" />
                    </div>
                    <div v-if="hasInvoiceSystem && !hasInvoiceSystemActive">
                        <button class="btn blue" @click="configureIntegration">Configure</button>
                    </div>
                    <div v-if="!hasInvoiceSystem">
                        <button class="btn blue" @click="activateInvoicing">Activate</button>
                    </div>
                </div>

                <!-- <div class="d-flex justify-content-between mb-2 align-items-center">
                    <div class="d-flex flex-column">
                        <span class="fs-small bold">Bookings set to this seller are invoiced</span>
                        <span class="dark fs-smaller">Automatic invoices are created when a new activity is booked for this channel.</span>
                    </div>
                    <div>
                        <v-select :searchable="false" :options="getInvoicingOptions" v-model="salesChannel.invoicing"></v-select>
                    </div>
                </div> -->

                <div class="d-flex justify-content-between mb-2 align-items-center" v-if="showTicketFormatPicker">
                    <div class="d-flex flex-column">
                        <span class="fs-small bold">Ticket format</span>
                    </div>
                    <div>
                        <v-select :searchable="false"  :options="getTicketTypes" v-model="salesChannel.ticketType_helper_selected" @input="ticketTypeChanged"></v-select>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { mapActions, mapGetters} from 'vuex'

export default {
    props:{
        salesChannel:{
            type: Object
        }
    },
    computed:{
        ...mapGetters([
            'getInvoicingOptions',
            'getTicketTypes',
            'getCompanySettings'
        ]),
        blockNameChange: function () {
            let blockedChannelTypes = new Array(50, 101)
            return blockedChannelTypes.includes(this.salesChannel.channelType) || this.salesChannel.isOTA
        },
        hasInvoiceSystem: function () {
            return this.getCompanySettings.settingsPresets.hasInvoiceSystem
        },
        hasInvoiceSystemActive: function () {
            return this.getCompanySettings.settingsPresets.invoiceSystem && this.getCompanySettings.settingsPresets.invoiceSystem.isActive
        },
        showTicketFormatPicker: function () {
            if (this.salesChannel.channelType == 101 || this.salesChannel.channelType == 50) {
                return false
            } else {
                return true
            }
        },
        disableTranpsortOption: function () {
            // return this.salesChannel.channelType == 101
            return false
        }
    },
    methods: {
        ...mapActions([
            'closeModal',
            'showUpgradePlanPopup'
        ]),
        ticketTypeChanged: function () {
            this.salesChannel.ticketType = this.salesChannel.ticketType_helper_selected.id
        },
        activateInvoicing: function () {
            this.showUpgradePlanPopup(true)
        },
        configureIntegration: function () {
            this.closeModal()
            // this.$router.push({ path: 'settings#integrations' })
            window.location.href = "/settings#integrations";
        }
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// salesChannelForm.vue?91097dca